jQuery(document).ready(function($) {

    $( ".bloc_valeurs_entites" ).each(function( index ) {

        var width = $(".cardsSlider").outerWidth() - $(window).width()

        gsap.to( $(".sliderContainer") , {
            x : -width,
            duration: 3,
            scrollTrigger: {
                trigger: $(".bloc_valeurs_entites .sliderContainer"),
                start: "top 0%",
                markers: false,
                pin: true,
                end: "+=3000",
                scrub : 1
            }

        })


    })

});